module.exports = __webpack_public_path__ + "static/media/TAPNYSwagDesign3.33c97011.jpeg";